import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import Routes from './routes'
import { AuthProvider } from './contexts/authContext'
import { ModalProvider } from './contexts/modalContext'
import moment from "moment"
import "moment/locale/pt-br"

moment.locale("pt-br")

const savedTheme = localStorage.getItem("@oktto:theme")
if (["light", "dark"].includes(savedTheme)) {
  document.documentElement.dataset.theme = savedTheme
}

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <AuthProvider>
      <ModalProvider>
        <Routes />
      </ModalProvider>
    </AuthProvider>
  </React.StrictMode>
)
